import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataStateChangeEventArgs, GridComponent, Sorts } from '@syncfusion/ej2-angular-grids';
import { Paginate, SearchWithPagination } from '../../../core/request/request.model';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class MsGridService {
	constructor() {}

	getData(paginate: any, grid: GridComponent, state: any): Observable<DataStateChangeEventArgs> {
		let sortQuery: any = [];
		let _currentPage = 0;
		let _pageSize = 0;
		let _query: string = '';

		const { currentPage, pageSize } = grid?.pageSettings || {};

		if (currentPage > 0 && pageSize > 0) {
			_currentPage = currentPage - 1;
			_pageSize = pageSize;
		}

		_query = `page=${_currentPage}&size=${_pageSize}`;

		if ((state?.sorted || []).length) {
			sortQuery = state.sorted
				.map((obj: Sorts) => {
					return obj.direction === 'descending' ? `${obj.name},desc` : `${obj.name},asc`;
				})
				.reverse();
		}

		let filterWhere = null;
		let isSearchWithOR = false;
		if (state && state.action === 'filter') {
			const { columns } = state;
			filterWhere = { predicates: columns };
		} else if (state && state.search && state.search.length > 0) {
			grid.clearSorting();
			isSearchWithOR = true;
			const _search = state.search[0];
			const _searchWhere = _search.fields.map((item: any) => {
				return { field: item, value: _search.key, operator: _search.operator };
			});
			filterWhere = { predicates: _searchWhere };
		} else if (state && state.where && state.where.length > 0) {
			const { where } = state;
			filterWhere = where[0];
		}

		if (filterWhere) {
			const __where = filterWhere.predicates.map(
				(item: { field: any; value: any; operator: any }) => {
					const _field = item.field;
					let _value: any = item.value;
					let _operator = item.operator;
					switch (_operator) {
						case 'equal':
							_operator = 'equals';
							break;
						case 'notequal':
							_operator = 'notEquals';
							break;
						case 'greaterthan':
							_operator = 'greaterThan';
							break;
						case 'greaterthanorequal':
							_operator = 'greaterThanOrEqual';
							break;
						case 'lessthan':
							_operator = 'lessThan';
							break;
						case 'lessthanorequal':
							_operator = 'lessThanOrEqual';
							break;
						case 'isnull':
							_operator = 'specified';
							_value = false;
							break;
						case 'isnotnull':
							_operator = 'specified';
							_value = true;
							break;
						case 'isempty':
							_operator = 'specified';
							_value = false;
							break;
						case 'isnotempty':
							_operator = 'specified';
							_value = true;
							break;
						case 'startswith':
						case 'endswith':
						case 'contains':
						case 'like':
							_operator = 'contains';
							break;
					}
					return `${_field}.${_operator}=${_value}`;
				}
			);
			_query += '&' + __where.join('&');
			if (isSearchWithOR) {
				_query += '&searchWithOR=true';
			}
		}

		const _pagination: SearchWithPagination = {
			page: _currentPage,
			size: _pageSize,
			sort: sortQuery,
			query: _query,
		};

		return paginate(_pagination).pipe(
			map((data: Paginate) => {
				return data as DataStateChangeEventArgs;
			})
		);
	}
}
